import { render, staticRenderFns } from "./IDControlDashboard.vue?vue&type=template&id=5a64235f&scoped=true"
import script from "./IDControlDashboard.vue?vue&type=script&lang=js"
export * from "./IDControlDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64235f",
  null
  
)

export default component.exports